import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import FixedLink from '@/components/FixedLink';
import { useDispatch } from 'react-redux';
import './App.css';
import '@/assets/css/animate.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fontsource/poppins';
import '@fontsource-variable/tilt-warp';
import route from './route';
import NewNav from '@/components/NewNav';
import BottomPage from '@/components/BottomNew';

// 不需要滚动到顶部的页面路径
const NO_NEED_TOP_PATHS = [];

// 自定义Hook：监听窗口大小变化并设置CSS变量
const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setSize({ width, height });
      
      // 设置CSS变量
      document.documentElement.style.setProperty('--vw', `${width / 100}px`);
      document.documentElement.style.setProperty('--vh', `${height / 100}px`);
      document.documentElement.style.setProperty('--window-width', `${width}px`);
      document.documentElement.style.setProperty('--window-height', `${height}px`);
      
      // 根据窗口宽度动态设置根字体大小
      const baseSize = 14;
      let fontSize = baseSize;
      
      if (width >= 1920) {
        fontSize = baseSize + 4;
      } else if (width >= 1200) {
        fontSize = baseSize + 2;
      } else if (width < 768) {
        fontSize = baseSize - 1;
      }
      
      document.documentElement.style.setProperty('--root-font-size', `${fontSize}px`);
    };
    
    // 添加事件监听
    window.addEventListener('resize', handleResize);
    handleResize(); // 初始化
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return size;
};

const RouteRenderer = () => {
  const location = useLocation();
  const routes = useRoutes(route);

  useEffect(() => {
    const currentPath = location?.pathname || '';
    const shouldScrollToTop = !NO_NEED_TOP_PATHS.some(path => 
      currentPath.includes(path)
    );

    if (shouldScrollToTop) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location.pathname]);

  return routes;
};

const AppContent = () => {
  useWindowSize(); // 调用hook监听窗口变化
  const location = useLocation();
  const currentPath = location?.pathname || '';
  
  // 不需要显示底部导航的页面路由列表
  const NO_FOOTER_PATHS = [];
  
  // 不需要显示导航和底部的页面（书籍详情页）
  const isBookDetailPage = currentPath.startsWith('/book/detail/');
  
  return (
    <>
      {!isBookDetailPage && <NewNav />}
      <div className='app_warp' style={{ 
        minHeight: NO_FOOTER_PATHS.includes(currentPath) || isBookDetailPage ? "100vh" : "calc(100vh - 125px)"
      }}>
        <Suspense>
          <RouteRenderer />
        </Suspense>
      </div>
      {/* 只有当前路由不在NO_FOOTER_PATHS列表中且不是书籍详情页时才显示底部导航 */}
      {!NO_FOOTER_PATHS.includes(currentPath) && !isBookDetailPage && <BottomPage key="global-footer" />}
      {!isBookDetailPage && <FixedLink />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;